import { createInput, type DefaultConfigOptions } from "@formkit/vue";
import { primeInputs, primeOutputs } from "@sfxcode/formkit-primevue";
import { en, fr } from "@formkit/i18n";
import { rules, messages } from "./formkit/validations";
import { customInputs } from "./formkit/definitions/inputs";
const config: DefaultConfigOptions = {
  inputs: {
    ...customInputs,
    ...primeInputs,
    ...primeOutputs,
  },
  rules: {
    ...rules,
  },
  messages: {
    ...messages,
  },
  locales: { en, fr },
  locale: "fr",
};

export default config;
